import React from "react";
// import Typed from "react-typed";
import Video from "../Assets/video.mp4";
// import { FaFileDownload } from "react-icons/fa";

const Home = () => {
  return (
    <div className="home-wraper">
      <div className="main-info">
        <video
          autoPlay
          loop
          muted
          src={Video}
          type="video/mp4"
          className="video"
        />
        <h1>
          Hello! I'm Prathamesh Sarode
          {/* <span>
            <Typed
              className="typed"
              strings={["Prathamesh", "Sarode"]}
              typeSpeed={60}
              backSpeed={50}
              loop
            />
          </span> */}
        </h1>
        <h2 className="main_skill">Full Stack Developer</h2>
        {/* <a
          href="https://drive.google.com/file/d/1aEcqKFtRrPUKaDw3mBKB88UIz4k6Klky/view?usp=sharing"
          target="_blank"
          rel="noreferrer"
          className="resume-button"
        >
          <FaFileDownload className="resume-logo" /> Download Resume
        </a> */}
      </div>
    </div>
  );
};

export default Home;
